import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TennisCalendarWrapper, TennisCourtesyMessage } from './styles';
import TennisDay from './TennisDay';
import ConfigManager from '../../common/configManager/configManager';
import { cleanTeamOrNameUrl } from '../../common/rcs_gaz_mc_core_FE';
//import TennisRow from '../../components/TennisRow';
//import TennisHeader from '../../components/TennisHeader';
import { getQuery } from '../../helpers';
import * as types from '../../constants/';

class TennisCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }
  componentDidMount() {
    this.resizeCallback();
    const { sportId, competitionId, seasonId } = window.matchcenterPage;
    const queryObj = getQuery(document.location);
    if (queryObj && queryObj.fase) {
      this.props.actions.getTennisCalendar(sportId, competitionId, true, seasonId, queryObj && queryObj.fase ? queryObj.fase : false);
    } else {
      this.props.actions.getTennisCalendar(sportId, competitionId, true, seasonId);
    }
    window.addEventListener('resize', this.resizeCallback);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  resizeCallback = () => {
    this.setState({
      isMobile: process.env.REACT_APP_SITE === 'gazzetta' ? window.innerWidth <= 1023 : window.innerWidth <= 767,
    });
  };

  prettySeasonTennisUrl = () => {
    const { tennisCalendar } = this.props;
    let competitionName = tennisCalendar.get('competitionName');
    const tournamentType = this.props.tennisCalendar.getIn(['tournament', 'tournamentType']);
    if (tournamentType && (tournamentType === types.DAVIS_CUP || tournamentType === types.FED_CUP)) {
      competitionName = cleanTeamOrNameUrl(tournamentType, '-', window.matchcenterPage.sportId);
    }
    return ConfigManager.prettySeasonTennisUrl(window.matchcenterPage.sportId, competitionName, false, process.env.REACT_APP_SITE);
  }

  linkGenerator = (link, string) => (
    <a href={link}>{string}</a>
  );

  courtesyMessage = (competitionSex) => {
    const defaultCourtesyMessage = 'Siamo spiacenti, il calendario del torneo non è ancora disponibile!';
    if (!competitionSex) return defaultCourtesyMessage;
    return 'Siamo spiacenti, il calendario del torneo non è ancora disponibile. Scopri gli altri tornei';
  }

  render() {
    const { isMobile } = this.state;
    const { tennisCalendar, currentTennisPhase } = this.props;
    const competitionSex = tennisCalendar && tennisCalendar.get('competitionSex');
    const competitionRounds = tennisCalendar && tennisCalendar.get('competitionRounds');
    const roundName = competitionRounds && competitionRounds.filter(round => round.get('name') === currentTennisPhase);
    let displayMatches = false;
    if (roundName && roundName.size) displayMatches = true;
    return (
      <TennisCalendarWrapper className="tennis-backurl" data-tennis_backurl={this.prettySeasonTennisUrl()}>
        {!displayMatches ?
          <TennisCourtesyMessage>{this.courtesyMessage(competitionSex)} {competitionSex && this.linkGenerator(this.prettySeasonTennisUrl(), 'qui')}</TennisCourtesyMessage>
        : roundName.map((r, index) => (
          <TennisDay
            key={index}
            tennisMatches={r}
            isMobile={isMobile}
            tournament={tennisCalendar.get('tournament')}
            competitionId={tennisCalendar.get('competitionId')}
          />
          ))}
      </TennisCalendarWrapper>
    );
  }
}

TennisCalendar.propTypes = {
  //dictionary: PropTypes.any,
  actions: PropTypes.any,
  tennisCalendar: PropTypes.any,
  currentTennisPhase: PropTypes.any,
};

export default TennisCalendar;



// WEBPACK FOOTER //
// ./src/containers/TennisCalendar/index.js